<mat-card class="response-card" [class.response-card--debug]="debug.enabled()">
  <mat-card-content class="response-body">

    @if (debug.enabled()) {
      <div class="debug-header">
        <mat-chip-set>
          <mat-chip class="debug-badge">{{ widgetType }}</mat-chip>
        </mat-chip-set>
        <span class="debug-info">
          {{ response?.query_result?.row_count ?? 0 }} row(s) · {{ response?.query_result?.columns?.length ?? 0 }} col(s)
        </span>
        @if (response?.query_result) {
          <button
            (click)="toggleRawData()"
            class="debug-toggle"
            >
            {{ showRawData() ? 'hide data' : 'raw data' }}
          </button>
        }
      </div>
      @if (showRawData() && response?.query_result) {
        <pre
          class="debug-raw"
        >{{ response!.query_result | json }}</pre>
      }
    }

    @if (widgetType === 'text') {
      <div class="text-content" [innerHTML]="safeHtml"></div>
    }

    @if (widgetType === 'code') {
      <p class="code-label">{{ columns[0]?.name | titlecase }}</p>
      <mat-chip-set>
        <mat-chip class="code-value">{{ rows[0]?.[0] ?? '—' }}</mat-chip>
      </mat-chip-set>
      @if (text) {
        <div class="widget-divider" aria-hidden="true"></div>
        <div class="text-content" [innerHTML]="safeHtml"></div>
      }
    }

    @if (widgetType === 'keyvalue') {
      @if (text) {
        <div class="text-content" [innerHTML]="safeHtml"></div>
        <div class="widget-divider" aria-hidden="true"></div>
      }
      <table class="kv-table">
        @for (pair of keyValuePairs; track pair.label) {
          <tr>
            <td class="kv-label">{{ pair.label }}</td>
            <td class="kv-value">{{ pair.value }}</td>
          </tr>
        }
      </table>
    }

    @if (widgetType === 'alert') {
      @if (text) {
        <div class="text-content" [innerHTML]="safeHtml"></div>
        <div class="widget-divider" aria-hidden="true"></div>
      }
      <div class="alert-list">
        @for (row of rows; track $index) {
          <div
            class="alert-item"
            >
            <mat-icon
              class="alert-icon"
              [color]="alertColor(row)"
            >notifications_active</mat-icon>
            <span class="alert-text">{{ alertLabel(row) }}</span>
            <mat-icon class="alert-link">open_in_new</mat-icon>
          </div>
        }
      </div>
    }

    @if (widgetType === 'line_chart') {
      @if (text) {
        <div class="text-content" [innerHTML]="safeHtml"></div>
        <div class="widget-divider" aria-hidden="true"></div>
      }
      <div class="chart-container">
        <colimo-chart-widget [queryResult]="response!.query_result!" mode="line_chart" />
      </div>
    }

    @if (widgetType === 'multi_line_chart') {
      @if (text) {
        <div class="text-content" [innerHTML]="safeHtml"></div>
        <div class="widget-divider" aria-hidden="true"></div>
      }
      <div class="chart-container">
        <colimo-chart-widget [queryResult]="response!.query_result!" mode="multi_line_chart" />
      </div>
    }

    @if (widgetType === 'bar_chart') {
      @if (text) {
        <div class="text-content" [innerHTML]="safeHtml"></div>
        <div class="widget-divider" aria-hidden="true"></div>
      }
      <div class="chart-container">
        <colimo-chart-widget [queryResult]="response!.query_result!" mode="bar_chart" />
      </div>
    }

    @if (widgetType === 'stacked_bar_chart') {
      @if (text) {
        <div class="text-content" [innerHTML]="safeHtml"></div>
        <div class="widget-divider" aria-hidden="true"></div>
      }
      <div class="chart-container">
        <colimo-chart-widget [queryResult]="response!.query_result!" mode="stacked_bar_chart" />
      </div>
    }

    @if (widgetType === 'gauge' || widgetType === 'box_plot' || widgetType === 'scatter_plot' || widgetType === 'histogram') {
      @if (text) {
        <div class="text-content" [innerHTML]="safeHtml"></div>
        <div class="widget-divider" aria-hidden="true"></div>
      }
      <colimo-data-table [columns]="columns" [rows]="rows" />
    }

    @if (widgetType === 'table') {
      @if (text) {
        <div class="text-content" [innerHTML]="safeHtml"></div>
        <div class="widget-divider" aria-hidden="true"></div>
      }
      <colimo-data-table [columns]="columns" [rows]="rows" />
    }

    @if (debug.enabled() && response?.sql_query) {
      <mat-expansion-panel
        class="sql-panel"
        >
        <mat-expansion-panel-header>
          <mat-panel-title class="sql-panel-title">Show SQL</mat-panel-title>
        </mat-expansion-panel-header>
        <pre class="sql-panel-body">{{ response!.sql_query }}</pre>
      </mat-expansion-panel>
    }

  </mat-card-content>

  @if (sourceTables.length > 0) {
    <mat-card-actions class="response-footer">
      <mat-chip-set>
        @for (src of sourceTables; track src) {
          <mat-chip
            class="source-table"
            disableRipple
            >
            <mat-icon class="source-icon">link</mat-icon>
            {{ src }}
          </mat-chip>
        }
      </mat-chip-set>
    </mat-card-actions>
  }
</mat-card>

@if (!streaming) {
  <div class="answer-meta">
    <button
      type="button"
      mat-icon-button
      class="answer-meta-copy"
      [matTooltip]="(copied() ? 'colimind.copied' : 'colimind.copyAnswer') | translate"
      (click)="copy()"
      >
      <mat-icon>{{ copied() ? 'check' : 'content_copy' }}</mat-icon>
    </button>
    @if (formattedDate) {
      <span class="answer-meta-time">{{ formattedDate }}</span>
    }
  </div>
}
